import { createApi, fetchBaseQuery } from '@reduxjs/toolkit/query/react'
import { API_PATH } from '../../config';
import { useMemo } from 'react';
import { useTranslation } from 'react-i18next';
import { useSelector } from 'react-redux';
import { addToast } from "../toast/toastsSlice"
import i18n from 'i18next';
import { parseErrorMessage } from '../../utils/strings';
import moment from 'moment';

export const AnnouncementApi = createApi({
  reducerPath: "AnnouncementApi",
  baseQuery: fetchBaseQuery({ 
    baseUrl: API_PATH, 
    prepareHeaders: (headers, { getState, endpoint }) => {
      const { user } = getState();
      headers.set('Authorization', `Token token="${user?.current?.auth?.key}"`)
      return headers
  },
   }),
  tagTypes: ['announcement'],
  endpoints: (builder) => ({
    getAnnouncements: builder.query({
      query: (arg) => {
        return { url : `/systemAnnouncement`};
      },
      providesTags: ['announcement'],
      transformResponse: (response, meta, arg) => {
        return response.map(item => {
          // Perform any transformation or filtering on each item here
          return {
            ...item,
            status: getAnnouncementStatus(item),
          };
        });
      }
    }),
    getUserAnnouncements: builder.query({
      query: (arg) => {
        return { url : `/systemAnnouncement/user`};
      },
      providesTags: ['announcementUser']
    }),
    saveAnnouncement: builder.mutation({
      query: (payload) => {
        let url = '/systemAnnouncement';

        if (payload.id) {
          url = `/systemAnnouncement/${payload.id}`;
        }

        return {
          url,
          method: payload.id ? 'PUT' : 'POST',
          body: payload,
        }
      },
      invalidatesTags: (result, error, arg)=>{
        return result ? ['announcement'] : [];
      },
    }),
    dismissAnnouncement: builder.mutation({
      query: (payload) => {
        let url = "/systemAnnouncement/dismiss/"+payload.id;

        return {
          url,
          method:'PUT',
          headers: {
            'Content-type': 'application/json; charset=UTF-8',
          },
        }
      },
      invalidatesTags: (result, error, arg)=>{
        return (!arg.preventInvalidate) ? ['announcement'] : [];
      },
    }),
    deleteAnnouncement: builder.mutation({
      query: (payload) => {
        let url = "/systemAnnouncement/"+payload.id;

        return {
          url,
          method:'DELETE',
          body: payload,
          headers: {
            'Content-type': 'application/json; charset=UTF-8',
          },
        }
      },
      invalidatesTags: (result, error, arg)=>{
        return (!arg.preventInvalidate) ? ['announcement'] : [];
      },
    })
  })
})

export const { 
  useGetAnnouncementsQuery,
  useGetUserAnnouncementsQuery,
  useDeleteAnnouncementMutation,
  useSaveAnnouncementMutation,
  useDismissAnnouncementMutation
} = AnnouncementApi

export const getAnnouncementStatus = announcement => {
  const now = moment();
  const startAt = announcement.startAt ? moment.parseZone(announcement.startAt) : null;
  const endAt = announcement.endAt ? moment.parseZone(announcement.endAt) : null;
  const validStartAt = startAt?.isValid();
  const validEndAt = endAt?.isValid();

  if (!announcement.isActive) return ANNOUNCEMENT_STATUS_CODE.DRAFT;
  if (validEndAt && now.isAfter(endAt)) return ANNOUNCEMENT_STATUS_CODE.EXPIRED;
  if (validStartAt && now.isBefore(startAt)) return ANNOUNCEMENT_STATUS_CODE.PUBLISHED;
  if (validStartAt && validEndAt && now.isBetween(startAt, endAt, undefined, '[]')) {
    return ANNOUNCEMENT_STATUS_CODE.LIVE;
  }
  return ANNOUNCEMENT_STATUS_CODE.PUBLISHED;
};

export const ANNOUNCEMENT_STATUS_CODE = {
  DRAFT: 1,
  PUBLISHED: 2,
  EXPIRED: 3,
  LIVE: 4,
};

export const ANNOUNCEMENT_STATUS = Object.fromEntries(
  Object.entries(ANNOUNCEMENT_STATUS_CODE).map(([status, code]) => [code, status])
);